module.exports = __webpack_public_path__ + "img/logo2.78435bef.png";